import { forwardRef, type Ref, type SVGProps } from "react";
const IconAIMagicOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16.485 18.328 6.98 27.835a.5.5 0 0 1-.708 0l-.707-.707a.5.5 0 0 1 0-.707l9.507-9.507zM25 16c.18 0 .3.12.3.299v.03a2.4 2.4 0 0 0 2.4 2.388.3.3 0 0 1 .3.298c0 .179-.12.298-.3.299a2.4 2.4 0 0 0-2.4 2.387c0 .18-.12.299-.3.299s-.3-.12-.3-.299a2.4 2.4 0 0 0-2.4-2.387c-.18 0-.3-.12-.3-.3 0-.178.12-.297.3-.297 1.32 0 2.4-1.075 2.4-2.389v-.03c0-.178.12-.298.3-.298m-6.356-2.658a1 1 0 0 1 1.414 1.414l-2.63 2.63-1.414-1.414z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2.946c.42 0 .7.279.7.697v.07l.007.285c.15 2.933 2.61 5.286 5.593 5.286l.13.014c.302.059.57.318.57.683l-.013.15c-.06.333-.32.547-.687.547l-.287.007c-2.948.15-5.313 2.596-5.313 5.565l-.012.15c-.06.333-.32.546-.688.546l-.15-.012a.64.64 0 0 1-.537-.535l-.013-.149c0-2.969-2.365-5.415-5.313-5.565l-.287-.007c-.42 0-.7-.279-.7-.697 0-.365.215-.624.55-.683l.15-.014c2.984 0 5.442-2.353 5.593-5.286l.007-.285v-.07c0-.418.28-.697.7-.697m0 4.992A7.7 7.7 0 0 1 8.952 9.98 7.7 7.7 0 0 1 11 12.023a7.7 7.7 0 0 1 2.047-2.043A7.7 7.7 0 0 1 11 7.937M23.35 4c.24 0 .401.16.401.398v.04l.004.163a3.203 3.203 0 0 0 3.195 3.021l.075.007a.4.4 0 0 1 .326.39l-.008.086c-.034.19-.183.313-.393.313l-.164.004c-1.684.086-3.035 1.483-3.035 3.18l-.008.085c-.034.19-.183.313-.392.313l-.086-.007a.36.36 0 0 1-.307-.306l-.008-.085c0-1.697-1.35-3.094-3.035-3.18l-.164-.004c-.24 0-.4-.16-.4-.398 0-.21.122-.357.313-.391l.087-.007a3.204 3.204 0 0 0 3.195-3.021l.004-.163v-.04c0-.238.16-.398.4-.398m0 2.587a4.24 4.24 0 0 1-1.435 1.433 4.24 4.24 0 0 1 1.436 1.431 4.24 4.24 0 0 1 1.434-1.431 4.24 4.24 0 0 1-1.434-1.433"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAIMagicOutlineSVG);
ForwardRef.displayName = "IconAIMagicOutline";
export { ForwardRef as IconAIMagicOutline };
